import { Col, Row } from "react-bootstrap";
import AdminBlockLink from "./AdminBlockLink";
import { BsDiagram3Fill, BsFillPersonFill, BsGrid3X3, BsJournalBookmarkFill } from "react-icons/bs";

const AdminSettingsBlock = () => {
    return(
        <>
        <div>
            <Row>
                <Col md={6}>
                    <AdminBlockLink info={
                        {link:"/admin_page_settings/users", 
                        label:"Пользователи", 
                        info_text:"Информация о пользователях в системе"}}>
                            <BsFillPersonFill />
                        </AdminBlockLink>
                </Col>
                <Col md={6}>
                    <AdminBlockLink info={
                        {link:"/admin_page_settings/facilities", 
                        label:"Предприятия", 
                        info_text:"Информация о предприятиях в системе"}}>
                            <BsDiagram3Fill />
                        </AdminBlockLink>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <AdminBlockLink info={
                        {link:"/admin_page_settings/tests", 
                        label:"Тесты", 
                        info_text:"Информация о тестах в системе"
                        }}>
                            <BsJournalBookmarkFill />
                        </AdminBlockLink>
                </Col>
                <Col md={6}>
                    <AdminBlockLink info={
                        {
                            link:"/admin_page_settings/logs", 
                            label:"Логи", 
                            info_text:"Информация о логах в системе"
                        }}>
                            <BsGrid3X3 />
                        </AdminBlockLink>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default AdminSettingsBlock;